export default "__VITE_ASSET__B6DTENgA__"